<div class="sidebar" [class.closed]="!isOpen()">
  <div class="sidebar__header">
    <div class="sidebar__header--logo">
      <img class="logo-icon" ngSrc="/assets/icons/logo-icon.svg" alt="logo" height="52" width="25" />
      @if (isOpen()) {
        <img class="logo-text" ngSrc="/assets/icons/logo-text.svg" alt="logo" height="23" width="109" />
      }
    </div>
    @if (isOpen()) {
      <p class="sidebar__header--text" @smallFontSizeAnimation>ELINOTIFY</p>
    } @else {
      <p class="sidebar__header--text">EN</p>
    }
  </div>
  <div class="sidebar__trigger">
    <i
      class="pi sidebar__trigger--icon"
      [ngClass]="isOpen() ? 'pi-arrow-left' : 'pi-arrow-right'"
      (click)="toggleSidebar.emit()"
      aria-hidden="true">
    </i>
  </div>
  <div class="sidebar__links">
    <app-sidebar-item
      [itemText]="'Groups'"
      [isSidebarOpen]="isOpen()"
      [activeItem]="activeItem"
      (click)="setActiveItem('Groups')"
      icon="pi pi-users"
      link="/groups" />
    @if (isTabAvailable('reminders')) {
      <app-sidebar-item
        [itemText]="'Reminders'"
        [isSidebarOpen]="isOpen()"
        [activeItem]="activeItem"
        (click)="setActiveItem('Reminders')"
        icon="pi pi-bell"
        link="/reminders" />
    }
    <hr class="sidebar__links-line" />
    @if (isTabAvailable('administration')) {
      <app-sidebar-item
        [itemText]="'Administration'"
        [isSidebarOpen]="isOpen()"
        [activeItem]="activeItem"
        [nestedItems]="administrationMenuConfig"
        [link]="null"
        (nestedItemEvent)="setActiveItem($event)"
        icon="pi pi-folder" />
    }
    @if (isTabAvailable('tg-users')) {
      <app-sidebar-item
        [itemText]="'Telegram Contacts'"
        [isSidebarOpen]="isOpen()"
        [activeItem]="activeItem"
        (click)="setActiveItem('Telegram Contacts')"
        icon="pi pi-list"
        link="/tg-users" />
    }
    @if (isTabAvailable('settings')) {
      <app-sidebar-item
        [itemText]="'System Settings'"
        [isSidebarOpen]="isOpen()"
        [activeItem]="activeItem"
        (click)="setActiveItem('System Settings')"
        icon="pi pi-cog"
        link="/settings" />
    }
  </div>
  <app-sidebar-footer [userData]="userData()" [isSidebarOpen]="isOpen()" (logout)="onLogoutEvent()" />
</div>
